import { InmateActivity } from '@reliance/types/models/InmateActivity';
import React, { useCallback, useEffect, useId, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { alertStore } from '../alert/alertStore';
import api from '../common/api';
import { formatCurrency } from '../format/Currency';

export type PhoneCardReverseModalProps = {
  show: boolean;
  activity: InmateActivity | null;
  onClose(saved: boolean): void;
};

const PhoneCardReverseModal: React.FC<PhoneCardReverseModalProps> = ({ show, activity, onClose }) => {
  const formId = useId();
  const [description, setDescription] = useState('');
  const [reversing, setReversing] = useState(false);

  useEffect(() => {
    if (show) {
      setDescription('');
      setReversing(false);
    }
  }, [show, activity?.id]);

  const handleDismiss = useCallback(() => {
    if (!reversing) {
      onClose(false);
    }
  }, [reversing, onClose]);

  const submit = useCallback(() => {
    if (activity?.id == null || reversing) {
      return;
    }
    setReversing(true);
    void api
      .delete(`/inmate-account/activity/${activity.id}`, {
        params: { description: description.trim() },
      })
      .then(
        () => {
          setReversing(false);
          alertStore.success('The phonecard load was reversed');
          onClose(true);
        },
        () => {
          setReversing(false);
          alertStore.error('An error occurred while reversing the load');
        }
      );
  }, [activity?.id, description, reversing, onClose]);

  const titleAmount = activity != null ? formatCurrency(-Number(activity.amount)) : '';

  return (
    <Modal show={show && activity != null} onHide={handleDismiss} backdrop={reversing ? 'static' : true}>
      <Modal.Header closeButton>
        <Modal.Title>
          Reverse {activity?.phonecard ?? ''} ({titleAmount}) Load
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          id={formId}
          onSubmit={(e) => {
            e.preventDefault();
            void submit();
          }}>
          <Form.Group className="mb-3">
            <Form.Label>Inmate Message</Form.Label>
            <Form.Control
              type="text"
              value={description}
              placeholder="Message to inmate"
              disabled={reversing}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="secondary" disabled={reversing} onClick={handleDismiss}>
          Cancel
        </Button>
        <Button
          form={formId}
          type="submit"
          variant="danger"
          disabled={reversing}>
          {reversing ? 'Reversing…' : 'Reverse'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PhoneCardReverseModal;
